import {
  FormControlLabel, Checkbox,
} from '@material-ui/core';
import {
  getIn, useFormikContext,
} from 'formik';
import React, {
  useEffect,
} from 'react';
import FieldError from '../../Utils/FieldError';
import {
  FieldPropsCommon, ToggleFieldValue,
} from '../types';
import {
  onChange,
} from '../utils';

type Props<T, K extends keyof T> = FieldPropsCommon<T, K> & ToggleFieldValue<T, K>;

const ToggleField = <FormModel, K extends keyof FormModel>(
  props: Props<FormModel, K>,
) => {
  const {
    values,
    handleChange,
    errors,
    touched,
    setFieldTouched,
    isSubmitting,
  } = useFormikContext<FormModel>();

  const {
    fieldOptions,
    disabled,
    title,
    location,
  } = props;

  const value: boolean = getIn(values, location);
  const onValueChange = onChange(handleChange, location);
  const error = getIn(errors, location);
  const isTouched = getIn(touched, location);

  useEffect(() => {
    if (isSubmitting) {
      setFieldTouched(location);
    }
  }, [isSubmitting, location, setFieldTouched]);

  return (
    <>
      <div
        style={{
          margin: 8,
        }}
      >
        <FormControlLabel
          control={(
            <Checkbox
              color="primary"
              {...(fieldOptions.switchProps || {
              })}
              disabled={disabled}
              checked={value}
              onBlur={() => setFieldTouched(location)}
              onChange={(newValue) => {
                onValueChange(newValue.target.checked);
              }}
            />
)}
          label={title}
          labelPlacement="end"
          style={{
            marginLeft: 0,
          }}
        />
      </div>
      <FieldError
        errors={error}
        touched={isTouched}
      />
    </>
  );
};

export default ToggleField;
